// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanEnrollmentMatrixCreateDto
 */
export interface IHealthPlanEnrollmentMatrixCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentMatrixCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentMatrixCreateDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentMatrixCreateDto
     */
    processing_rule_id?: number;
}

/**
 * Check if a given object implements the IHealthPlanEnrollmentMatrixCreateDto interface.
 */
export function instanceOfIHealthPlanEnrollmentMatrixCreateDto(value: object): value is IHealthPlanEnrollmentMatrixCreateDto {
    return true;
}

export function IHealthPlanEnrollmentMatrixCreateDtoFromJSON(json: any): IHealthPlanEnrollmentMatrixCreateDto {
    return IHealthPlanEnrollmentMatrixCreateDtoFromJSONTyped(json, false);
}

export function IHealthPlanEnrollmentMatrixCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanEnrollmentMatrixCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'processing_rule_id': json['processing_rule_id'] == null ? undefined : json['processing_rule_id'],
    };
}

export function IHealthPlanEnrollmentMatrixCreateDtoToJSON(json: any): IHealthPlanEnrollmentMatrixCreateDto {
    return IHealthPlanEnrollmentMatrixCreateDtoToJSONTyped(json, false);
}

export function IHealthPlanEnrollmentMatrixCreateDtoToJSONTyped(value?: IHealthPlanEnrollmentMatrixCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'processing_rule_id': value['processing_rule_id'],
    };
}

